import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives, vModelText as _vModelText, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "data-type"]
const _hoisted_2 = ["for"]
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "drop-arrow" }, null, -1 /* HOISTED */)
const _hoisted_5 = ["type"]
const _hoisted_6 = { class: "error-msg" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.withoutSyncWrapper !== true)
      ? (_openBlock(), _createBlock($setup["MarketoInputSyncWrapper"], {
          key: 0,
          modelValue: $setup.proxyModelValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.proxyModelValue) = $event)),
          "marketo-input-name": $props.formInputMeta.marketoName
        }, null, 8 /* PROPS */, ["modelValue", "marketo-input-name"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      id: 'parent_' + $props.formInputMeta.marketoName,
      class: _normalizeClass(["parent-field-wrpr", $setup.parentWrapperClasses]),
      "data-type": $props.formInputMeta.type
    }, [
      _createElementVNode("label", {
        class: "eclipse-label",
        for: $props.formInputMeta.name
      }, _toDisplayString($setup.translate($setup.FormLabelKeysEnum[$props.formInputMeta.name], { ns: $setup.TranslationNamespaceEnum.formLabels })), 9 /* TEXT, PROPS */, _hoisted_2),
      _renderSlot(_ctx.$slots, "input", {}, () => [
        ($props.formInputMeta.type === 'select')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createElementVNode("select", _mergeProps({
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.proxyModelValue) = $event))
              }, $setup.commonInputProps), [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.dropdownOptionKeys, (key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: key
                  }, _toDisplayString($setup.translate(key, { ns: $props.dropdownTranslationsNamespace })), 9 /* TEXT, PROPS */, _hoisted_3))
                }), 128 /* KEYED_FRAGMENT */))
              ], 16 /* FULL_PROPS */), [
                [_vModelSelect, $setup.proxyModelValue]
              ]),
              _hoisted_4
            ], 64 /* STABLE_FRAGMENT */))
          : ($props.formInputMeta.type === 'textarea' && !$setup.isBoolean($setup.proxyModelValue))
            ? _withDirectives((_openBlock(), _createElementBlock("textarea", _mergeProps({
                key: 1,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.proxyModelValue) = $event))
              }, $setup.commonInputProps), "\r\n        ", 16 /* FULL_PROPS */)), [
                [_vModelText, $setup.proxyModelValue]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
                key: 2,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.proxyModelValue) = $event))
              }, $setup.commonInputProps, {
                type: $props.formInputMeta.type
              }), null, 16 /* FULL_PROPS */, _hoisted_5)), [
                [_vModelDynamic, $setup.proxyModelValue]
              ])
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString($setup.translate($props.formInputMeta.name + "_Error", { ns: $setup.TranslationNamespaceEnum.formValidation })), 1 /* TEXT */)
    ], 10 /* CLASS, PROPS */, _hoisted_1)
  ], 64 /* STABLE_FRAGMENT */))
}